import { render, staticRenderFns } from "./InfoSection.vue?vue&type=template&id=5f93d136&scoped=true&"
import script from "./InfoSection.vue?vue&type=script&lang=js&"
export * from "./InfoSection.vue?vue&type=script&lang=js&"
import style0 from "./InfoSection.vue?vue&type=style&index=0&id=5f93d136&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f93d136",
  null
  
)

export default component.exports